<script setup lang="ts">
defineProps<{ horizontal?: boolean; compact?: boolean }>();
</script>

<template>
  <div class="menu-item-delimiter" :class="{ horizontal, compact }" />
</template>

<style lang="scss" scoped>
@use "@/styles/board";
@use "@/styles/variables/colors";

.menu-item-delimiter {
  width: 2px;
  height: 16px;
  background-color: colors.$border-subtle;
  margin-left: 4px;
  margin-right: 4px;

  &.horizontal {
    width: 16px;
    height: 2px;
    margin: 4px 0;
  }

  // Compact lives in a board-scale context (currently only ArtObjectiveCell),
  // so dimensions go through board.len to follow the fluid-board transform.
  &.compact {
    width: board.len(1px);
    height: board.len(8px);
    margin: 0;

    &.horizontal {
      width: board.len(8px);
      height: board.len(1px);
    }
  }
}
</style>
